import React from "react";
var ConfirmationModal = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, message = _a.message, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    if (!isOpen)
        return null;
    return (React.createElement("div", { className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" },
        React.createElement("div", { className: "bg-gray-800 p-6 rounded-lg shadow-lg w-96" },
            React.createElement("h2", { className: "text-white text-lg font-semibold mb-4" }, title),
            React.createElement("p", { className: "text-gray-300 mb-6" }, message),
            React.createElement("div", { className: "flex justify-end gap-4" },
                React.createElement("button", { onClick: onCancel, className: "px-4 py-2 bg-gray-600 text-white rounded-lg shadow-md hover:bg-gray-700 transition-all duration-300" }, "Cancelar"),
                React.createElement("button", { onClick: onConfirm, className: "px-4 py-2 bg-red-600 text-white rounded-lg shadow-md hover:bg-red-700 transition-all duration-300" }, "Excluir")))));
};
export default ConfirmationModal;
